import { render, staticRenderFns } from "./DataFetch.vue?vue&type=template&id=3aa31739&"
import script from "./DataFetch.vue?vue&type=script&lang=js&"
export * from "./DataFetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports